export const WithoutOrganization = Symbol('WithoutOrganization');
export type WithoutOrganization = typeof WithoutOrganization;
